import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import Footer from "@/components/Footer";
import BottomNav from "@/components/BottomNav";
import FloatingCheckout from "@/components/FloatingCheckout";
import FeaturesSection from "@/components/FeaturesSection";
import ProductCarouselSection from "@/components/ProductCarouselSection";
import SizeUpSection from "@/components/SizeUpSection";
import PromoBanner from "@/components/PromoBanner";
import CombosSection from "@/components/CombosSection";
import ReviewsSection from "@/components/ReviewsSection";
import AboutTeaser from "@/components/AboutTeaser";

const Index = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const scrollTarget = searchParams.get("scroll");
    if (scrollTarget) {
      const timer = setTimeout(() => {
        const el = document.getElementById(scrollTarget);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen pb-20 md:pb-0 overflow-x-hidden w-full relative bg-white">
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <ProductCarouselSection />
        <PromoBanner />
        <CombosSection />
        <FeaturesSection />
        <AboutTeaser />
        <SizeUpSection />
        <ReviewsSection />
      </main>
      <Footer />
      <BottomNav />
      <FloatingCheckout />
    </div>
  );
};

export default Index;
